export const redirectSetAction = url => ({
  widget: 'global',
  type: 'redirectSet',
  payload: url,
})



// WEBPACK FOOTER //
// ./src/global/actions/redirectSet.js